import { render, staticRenderFns } from "./todos_toggle.vue?vue&type=template&id=65d26152"
import script from "./todos_toggle.vue?vue&type=script&lang=js"
export * from "./todos_toggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports